import React from 'react';

import ReactECharts from 'echarts-for-react';


const BarChart = ({
  data = [],
  xLabels = [],
  barColor = 'rgba(178, 188, 203, 1)',
  height = 400,
  yAxisInterval, // <-- Added this prop,
  tooltipFormatter
}) => {

  // Check for mismatch between xLabels and data
  if (xLabels.length !== data.length) {
    console.warn('BarChart: xLabels and data length mismatch!', xLabels, data);
  }

  // Calculate dynamic yAxis max and interval
  const maxData = Math.max(...data, 0);
  let yInterval = 1;
  let yMax = maxData;
  // Dynamically set interval to avoid label overlap and show reasonable ticks
  if (maxData > 0) {
    if (maxData <= 10) {
      yInterval = 1;
      yMax = Math.ceil(maxData / yInterval) * yInterval;
    } else if (maxData <= 50) {
      yInterval = 5;
      yMax = Math.ceil(maxData / yInterval) * yInterval;
    } else if (maxData <= 100) {
      yInterval = 10;
      yMax = Math.ceil(maxData / yInterval) * yInterval;
    } else if (maxData <= 500) {
      yInterval = 50;
      yMax = Math.ceil(maxData / yInterval) * yInterval;
    } else if (maxData <= 1000) {
      yInterval = 100;
      yMax = Math.ceil(maxData / yInterval) * yInterval;
    }  else if (maxData <= 1500) {
      yInterval = 500;
      yMax = Math.ceil(maxData / yInterval) * yInterval;
    } else {
      yInterval = 100;
      yMax = Math.ceil(maxData / 100) * 100;
    }
  }

  // Use provided interval if available
  if (typeof yAxisInterval === 'number' && yAxisInterval > 0) {
    yInterval = yAxisInterval;
    yMax = Math.ceil(maxData / yAxisInterval) * yAxisInterval;
  }

  console.log('yInterval', yInterval, 'yMax', yMax);
  const option = {
    xAxis: {
      type: 'category',
      data: xLabels,
      axisLabel: {
        interval: 0,
        rotate: 0,
      },
      axisTick: {
        alignWithLabel: true
      }
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: yMax,
      // interval: yInterval ,
      interval: yMax > 900 ? Math.ceil(yMax / 8) : yInterval,
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dotted',
          color: '#E5E8EC',
        },
      },
      axisLabel: {
        fontSize: 14, // Increase this value for larger font
      },
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
    },
    series: [
      {
        data: data,
        type: 'bar',
        showBackground: true,
        barWidth: '60%',
        itemStyle: {
          color: barColor,
        },
        backgroundStyle: {
          color: 'rgba(178, 188, 203, 0.2)'
        },
      }
    ]
  };

  return <ReactECharts style={{ height, width: '100%' }} option={option} />;
};

export default BarChart;
